var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSafetyCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.265 2.076C12.1029 1.97467 11.8971 1.97467 11.735 2.076L10.5973 2.78707C8.92507 3.83221 6.86154 4.03908 5.01513 3.34668C4.28202 3.07176 3.5 3.61371 3.5 4.39666V11.4763C3.5 16.4319 6.87945 20.7488 11.6902 21.9385C11.8937 21.9888 12.1063 21.9888 12.3098 21.9385C17.1205 20.7488 20.5 16.4319 20.5 11.4763V4.39666C20.5 3.6137 19.718 3.07176 18.9849 3.34667C17.1385 4.03908 15.0749 3.83221 13.4027 2.78707L12.265 2.076ZM16.8536 8.64645C17.0488 8.84171 17.0488 9.15829 16.8536 9.35355L11.8536 14.3536C11.6583 14.5488 11.3417 14.5488 11.1464 14.3536L8.14645 11.3536C7.95118 11.1583 7.95118 10.8417 8.14645 10.6464C8.34171 10.4512 8.65829 10.4512 8.85355 10.6464L11.5 13.2929L16.1464 8.64645C16.3417 8.45118 16.6583 8.45118 16.8536 8.64645Z",
    fill: "#2B2B2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyCheck);
export default __webpack_public_path__ + "static/media/SafetyCheck.deb51adfc1debbcdc4c14cd22efa3991.svg";
export { ForwardRef as ReactComponent };